import logger from "~/helpers/logger";
import { readAppVersion } from "~/helpers/sw/precacheOwnBuild";

const fetchAvailableVersion = async (): Promise<string | null> => {
	try {
		const response = await fetch(`/index.html?t=${Date.now()}`, { cache: "no-store" });
		if (!response.ok) return null;
		return readAppVersion(await response.text());
	} catch (error) {
		logger.warn("Unable to probe available app version", error);
		return null;
	}
};

export default fetchAvailableVersion;
